module.exports = __webpack_public_path__ + "static/img/gadget_windows.daab99c1.svg";